import { ArrowLongRightIcon } from "@heroicons/react/24/solid";
import { NextSeo } from "next-seo";
import { ReactElement } from "react";
import { Banner } from "~/components/Banner";
import Button, { ButtonColor } from "~/components/Button";
import { ResponsiveImage } from "~/components/ResponsiveImage";
import { MainLayout } from "~/components/layouts/MainLayout";
import { NextPageWithLayout } from "~/pages/_app";
import { AboutUsPageContent as content } from "~/content/o-nas/content.pl";
import aboutHeroImage from "~/src/assets/images/hero-houses-aerial.jpg";

const AboutPage: NextPageWithLayout = () => {
  return (
    <>
      <Banner title={content.seo.title} />
      <div className="flex flex-grow flex-wrap lg:flex-nowrap">
        <ResponsiveImage
          className="order-1 lg:order-1 lg:h-auto lg:w-1/2"
          src={aboutHeroImage}
          priority
          sizes="(min-width: 1024px) 50vw, 100vw"
          alt="Panorama osiedla domów jednorodzinnych z lotu ptaka"
        />
        <div className="order-1 flex flex-col justify-center gap-4 px-4 py-8 sm:px-6 sm:py-12 lg:w-1/2 lg:px-16 lg:py-20">
          <h2 className="font-bold h2">{content.title}</h2>
          <div className="space-y-4 text-gray-700">
            {content.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>

          <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
            <p className="text-sm font-semibold uppercase tracking-wide text-slate-500">
              {content.highlightsTitle}
            </p>
            <ul className="mt-4 space-y-3">
              {content.highlights.map((highlight) => (
                <li key={highlight} className="flex items-start gap-3 text-sm text-slate-700">
                  <span className="mt-2 h-2 w-2 flex-shrink-0 rounded-full bg-sky-600" />
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
            <p className="mt-4 text-sm font-medium leading-6 text-slate-700">
              {content.closing}
            </p>
          </div>

          <Button
            href="/kontakt"
            color={ButtonColor.Primary}
            className="mb-10 mt-10 w-fit"
            size="xl"
            outline
          >
            Skontaktuj się z nami
            <ArrowLongRightIcon className="ml-2 h-7 w-7" />{" "}
          </Button>
        </div>
      </div>
    </>
  );
};

AboutPage.getLayout = function GetLayout(page: ReactElement) {
  return (
    <MainLayout>
      <NextSeo
        title={content.seo.title}
        description={content.seo.description}
      />
      {page}
    </MainLayout>
  );
};

export default AboutPage;
